import React, { Fragment, useCallback, useEffect, useState } from "react";
import "./index.css";
import { Button, Row, Space, Card, Typography, Radio, Spin, Empty } from "antd";
import { loadAddresses } from "../../../application/addresses";
import { useAppDispatch, useAppSelector } from "../../../application/store";
import I18n from "../../i18n";
import { LeftOutlined, PlusOutlined } from "@ant-design/icons";
import { isMobile } from "react-device-detect";
import NewAddressModal from "../Profile/components/Addresses/components/NewAddressModal";
import { Link } from "react-router-dom";

export default function SelectAddress() {
  const dispatch = useAppDispatch();
  const { loadingAddresses, addresses } = useAppSelector(
    (state) => state.addresses
  );
  const [newAddressModalVisible, setNewAddressModalVisible] = useState(false);
  const openNewAddressDialog = () => setNewAddressModalVisible(true);
  const closeNewAddressDialog = () => setNewAddressModalVisible(false);

  const [selectedAddress, setSelectedAddress] = useState<string>();

  const stableDispatch = useCallback(dispatch, []);
  useEffect(() => {
    stableDispatch(loadAddresses());
  }, [stableDispatch]);

  const isLoading = loadingAddresses === "pending";
  return (
    <Spin spinning={isLoading}>
      <div style={{ margin: isMobile ? '15px' : 0 }}>
        <Card style={isMobile ? {} : { margin: 32 }} bodyStyle={{ padding: 0 }}>
          {addresses?.length === 0 ? (
            <Empty
              style={{ padding: "64px 0" }}
              description={
                <span>
                  هیچ آدرسی در پروفایل شما ثبت نشده است.
                  <br />
                  جهت ادامه فرآیند خرید یک آدرس جدید ایجاد نمایید.
                </span>
              }
            >
              <Button
                type="primary"
                onClick={openNewAddressDialog}
                icon={<PlusOutlined />}
              >
                {I18n.profile.addNewAddress}
              </Button>
            </Empty>
          ) : (
            <Fragment>
              <div style={{ padding: 16, paddingBottom: 0 }}>
                <Typography.Title level={5}>
                  آدرس مورد نظر خود جهت ارسال بسته را انتخاب نمایید
                </Typography.Title>
              </div>
              <Radio.Group
                className="address-radio-group"
                onChange={(e) => setSelectedAddress(e.target.value)}
              >
                {addresses?.map((address) => {
                  return (
                    <Radio className="address-radio-item" value={address.id}>
                      <span className="addrees-item-title">{`${address.state}، ${address.city}`}</span>
                      <br />
                      <span className="addrees-item-detail">
                        {address.address}
                      </span>
                      {address.zipCode === "" ? (
                        <Fragment />
                      ) : (
                        <Fragment>
                          <br />
                          <span className="addrees-item-detail">
                            {address.zipCode}
                          </span>
                        </Fragment>
                      )}
                    </Radio>
                  );
                })}
              </Radio.Group>
            </Fragment>
          )}

          {addresses?.length === 0 ? (
            <Fragment />
          ) : (
            <Button type="link" block onClick={openNewAddressDialog}>
              <Row justify="space-between" align="middle">
                <Row align="middle">
                  <Space>
                    <PlusOutlined />
                    <div className="add-new-address-button">
                      {I18n.profile.addNewAddress}
                    </div>
                  </Space>
                </Row>
                <LeftOutlined />
              </Row>
            </Button>
          )}

          {addresses?.length === 0 ? (
            <Fragment />
          ) : (
            <Row justify="end" style={{ margin: 16 }}>
              <Button
                type="primary"
                block={isMobile}
                disabled={selectedAddress === undefined}
              >
                <Link to={`/shipping?address=${selectedAddress}`}>
                  {selectedAddress === undefined
                    ? "برای ادامه آدرس را انتخاب کنید"
                    : "تایید و ادامه"}
                </Link>
              </Button>
            </Row>
          )}

          <NewAddressModal
            visible={newAddressModalVisible}
            onClose={closeNewAddressDialog}
          />
        </Card>
      </div>
    </Spin>
  );
}
